import React from 'react'
import { Autocomplete, Card, CardContent, Grid, TextField } from '@mui/material'
import Input from 'common/components/form/Input'
import PropTypes from 'prop-types'
import { getDate } from 'common/utils/DateUtil'
import DateTimePicker from 'common/components/form/DateTimePicker'
import ContextMenu from 'common/components/ContextMenu'

const NoteCard = ({
    note = {},
    readMode,
    shortMode,
    onChange = () => {},
    contextActions = [],
    typeOptions = [],
}) => (
    <Card>
        <ContextMenu actions={contextActions}>
            <CardContent>
                {readMode ? (
                    <Grid container spacing={1} justifyContent='flex-end'>
                        <Grid size={12} sx={{ fontWeight: 'bold' }} container justifyContent='space-between' spacing={1}>
                            {note.typeNote}
                            <Grid>{getDate(note.creationDate)}</Grid>
                        </Grid>
                        <Grid size={12} sx={{ whiteSpace: 'pre-line', ...(shortMode ? { fontSize: '14px' } : {}) }}>
                            {shortMode ?
                                `${note.comment?.substring(0, 200)}${note?.comment?.length > 200 ? '...' : ''}`
                                : note.comment}
                        </Grid>
                        <Grid size='auto' sx={{ fontSize: '12px', fontStyle: 'italic' }}>{`MAJ le ${getDate(note.updateDate ?? note.creationDate)} par ${note.updateLogin ?? note.creationLogin}`}</Grid>
                    </Grid>
                ) : (
                    <Grid container spacing={1} alignItems='center'>
                        <Grid size={8}>
                            <Autocomplete
                                freeSolo
                                options={typeOptions}
                                // Freesolo « le texte saisi = la valeur » : on ne contrôle QUE l'inputValue
                                // (onInputChange capture aussi la sélection d'une option, reason 'reset').
                                // Contrôler aussi value/onChange re-synchronise l'input et annule la frappe.
                                inputValue={note.typeNote ?? ''}
                                onInputChange={(_, v) => onChange({ ...note, typeNote: v })}
                                disabled={readMode}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Type *'
                                        slotProps={{
                                            input: { ...params.InputProps, notched: false },
                                            inputLabel: { ...params.InputLabelProps, shrink: false },

                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={4}>
                            <DateTimePicker
                                label='Date de la note'
                                value={note.creationDate}
                                onChange={(v) => onChange({ ...note, creationDate: v })}
                                disabled={readMode}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Input
                                label='Commentaire'
                                value={note.comment}
                                onChange={(v) => onChange({ ...note, comment: v })}
                                disabled={readMode}
                                multiline
                                rows={20}
                            />
                        </Grid>
                    </Grid>
                )}
            </CardContent>
        </ContextMenu>
    </Card>
)

export default NoteCard

NoteCard.propTypes = {
    note: PropTypes.shape({
        idClient: PropTypes.number,
        id: PropTypes.number,
        typeNote: PropTypes.string,
        comment: PropTypes.string,
        creationDate: PropTypes.instanceOf(Date),
        creationLogin: PropTypes.string,
        updateDate: PropTypes.instanceOf(Date),
        updateLogin: PropTypes.string,
    }).isRequired,
    readMode: PropTypes.bool,
    shortMode: PropTypes.bool,
    onChange: PropTypes.func,
    typeOptions: PropTypes.arrayOf(PropTypes.string),
    contextActions: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        displayed: PropTypes.bool,
    })),
}